import React from 'react';
import { Tag } from "@phosphor-icons/react";

interface ContactPickerButtonProps {
  entityId: number;
  entityType: 'contact' | 'company';
  currentTags: string[];
  className?: string;
}

export const ContactPickerButton: React.FC<ContactPickerButtonProps> = ({
  entityId,
  entityType,
  currentTags = [],
  className = ''
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();

    // Dispatch event to centralized picker handler
    window.dispatchEvent(new CustomEvent('contact-tags-picker', {
      detail: {
        entityId,
        entityType,
        currentTags: [...currentTags] // Snapshot
      }
    }));
  };

  const displayValue = currentTags && currentTags.length > 0
    ? currentTags.length === 1
      ? currentTags[0]
      : `${currentTags[0]} +${currentTags.length - 1}`
    : null;

  return (
    <button
      onClick={handleClick}
      className={`w-full text-left px-1.5 py-1 h-full rounded-sm border text-[11px] hover:bg-muted-foreground/10 border-muted-foreground/20 bg-muted text-muted-foreground transition-all duration-200 ease-in-out hover:shadow-sm hover:border-moss-primary/40 focus:ring-2 focus:ring-moss-primary/20 focus:outline-hidden min-w-0 ${className}`}
    >
      <div className="flex items-center gap-1 min-w-0">
        <Tag className="h-3 w-3 text-muted-foreground shrink-0" />
        <span className="truncate">
          {displayValue || 'Geen tags'}
        </span>
      </div>
    </button>
  );
};
